import { Component } from '@angular/core';
import { Mode, PageKey, Role } from '../../const';
import { SearchService } from '../common/search.service';

export enum Tabs { Module = "Module", SubCategory = "Analytics Toolkit", Metrics = "Metric" } 

@Component({
    selector: 'app-data-management',
    templateUrl: './data-management.component.html',
})
export class DataManagementComponent {
  showForm: boolean = false;
  activeTab: string = Tabs.Module;
  tabs = Tabs;
  pageTitle: string = "";
  mode = Mode;
  hideGlobalCreate: boolean = false;
  roles = Role;
  searchTerm: string = "";
  pageKey = PageKey.DataManagementCenter;
  searchTriggered: boolean = false;
  searchBy: string = "Search by Module / Analytics Toolkit / Metric";

  constructor(private readonly searchService: SearchService) { }

  ngOnInit(): void {
    this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
  }
  
  setTabName(tabName: string){
    this.hideGlobalCreate = false;
    this.activeTab = tabName;
    //this.searchTerm = "";
    if(this.activeTab == Tabs.Module){
      this.searchBy = "Search by Module / Analytics Toolkit / Metric";
    }
    else if(this.activeTab == Tabs.SubCategory || Tabs.Metrics){
      this.searchBy = "Search by Analytics Toolkit / Metric";
    }
  }

  showCreateForm() {
    this.showForm = true;
  }

  closeCreateForm() {
    this.showForm = false;
    this.pageTitle = "";
    this.searchTriggered = false;
  }

  setPageTitleTriggered(value: any){
    this.pageTitle = value.mode + ' ' + value.tab;
  }

  hideCreate(value: boolean){
    this.hideGlobalCreate = value;
  }

  onSearch(){
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    this.searchTriggered = true;
  }
}
